var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "tile is-ancestor is-parent": true } },
    [
      _c("phone-list", {
        attrs: {
          phones: _vm.phones,
          v: _vm.$v.entity.phones,
          "is-tiled": _vm.isTiled,
        },
      }),
      _c("email-list", {
        attrs: {
          emails: _vm.emails,
          v: _vm.$v.entity.emails,
          "is-tiled": _vm.isTiled,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }